<template>
  <PageTemplate alternative>
    <v-sheet width="100%" min-height="100vh" class="py-md-16 item">
      <v-container v-if="isPregnancyCoursesActive" :fluid="mdAndDown">
        <div
          class="
            d-flex
            flex-column flex-sm-row
            align-center
            justify-space-between
            item-header
          "
        >
          <img
            src="../assets/img/hospital-dois-pinheiros.png"
            class="d-block my-5"
            height="78px"
          />

          <img
            v-if="!xsOnly"
            :src="files + logo"
            class="d-block my-5"
            height="127px"
          />

          <img
            v-if="!xsOnly"
            src="../assets/img/maternidade.png"
            class="d-block my-5"
            height="50px"
          />

          <v-sheet
            width="100%"
            color="transparent"
            v-if="xsOnly"
            class="d-flex align-center justify-space-around"
          >
            <img :src="files + logo" class="d-block my-5" height="80px" />
            <img
              src="../assets/img/maternidade.png"
              class="d-block my-5"
              height="40px"
            />
          </v-sheet>
        </div>

        <div class="justify-center align-center item-content">
          <v-img
            class="item-content-img"
            src="../assets/img/womans.png"
            contain
            width="100%"
          ></v-img>

          <div class="item-content-form">
            <BreastfeedingJourney :title="title" />
          </div>
        </div>
      </v-container>
      <v-sheet
        color="transparent"
        height="100%"
        class="d-flex align-center justify-center"
        v-if="!loading && !isPregnancyCoursesActive"
      >
        <v-row justify="center">
          <v-col cols="12" lg="6" class="d-flex justify-center flex-column">
            <span
              class="
                text-center
                font-weight-regular
                text-h6 text-sm-h5 text-md-h4
                alternative--text
              "
              v-html="alternativeText"
            ></span>

            <div class="d-flex justify-center pt-6">
              <v-btn
                color="#FE8A00"
                class="text-h6 white--text text-none px-8 mt-2"
                height="48px"
                depressed
                rounded
                to="/"
              >
                Voltar para o site
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-sheet>
    </v-sheet>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../templates/Page.vue";
import BreastfeedingJourney from "../forms/BreastfeedingJourney.vue";

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest("breastfeeding-journey")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    pregnancyCourses() {
      return this.$rest("breastfeeding-journey").item;
    },
    isPregnancyCoursesActive() {
      return this.pregnancyCourses.active;
    },
    title() {
      return this.pregnancyCourses.title;
    },
    alternativeText() {
      return this.pregnancyCourses.alternative_text;
    },
    logo() {
      return this.pregnancyCourses.img;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    PageTemplate,
    BreastfeedingJourney,
  },
};
</script>

<style lang="scss" scoped>
.alternative {
  background-color: #fe8a00;
  &--text {
    color: #fe8a00;
  }
}
.item {
  background: url(../assets/img/left.png) no-repeat left top 100% fixed,
    url(../assets/img/right.png) no-repeat right top 100% fixed;

  &-content {
    display: grid;
    gap: 40px;
    grid-template-columns: minmax(auto, 600px);
    margin-top: 80px;

    @media screen and (max-width: 600px) {
      margin-top: 40px;
    }

    @media screen and (max-width: 960px) {
      grid-template-areas:
        "form"
        "img";

      &-img {
        grid-area: img;
      }

      &-form {
        grid-area: form;
      }
    }

    @media screen and (min-width: 960.001px) {
      gap: 40px;
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
